<template>
  <span>
    <template v-if="!slotData.human">
      <LinkItem
        v-if="slotData.to"
        :item="{ ...item, [slotData.name]: date, name: date }"
        :slotData="slotData"
      ></LinkItem>
      <template v-else>
        {{ date }}
      </template>
    </template>
    <v-tooltip top v-else>
      <template v-slot:activator="{ on }">
        <LinkItem
          v-if="slotData.to"
          :item="{ ...item, [slotData.name]: humanDate, name: humanDate }"
          :slotData="slotData"
          v-on="on"
        ></LinkItem>
        <template v-else>
          <span v-on="on">{{ humanDate }}</span>
        </template>
      </template>
      <span>{{ date }}</span>
    </v-tooltip>
  </span>
</template>

<script>
import LinkItem from "./LinkItem";
import moment from "moment";
export default {
  components: { LinkItem },
  name: "DateItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  computed: {
    date() {
      let date = this.item[this.slotData.name];
      return (
        (date &&
          this.$dateTime(
            new Date(date),
            this.slotData.dateFormat || "long",
            this.slotData.dateLocale || "",
            this.slotData.dateTimeZone || ""
          )) ||
        ""
      );
    },
    humanDate() {
      let date = this.item[this.slotData.name];
      moment.locale(this.$i18n.locale);
      return date && moment(date).fromNow();
    }
  }
};
</script>

<style scoped></style>
